export default __webpack_public_path__ + "static/media/1.31552c36.jpg";